/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  isActive?: boolean;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 16, height = 16, color="#257B7A" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path d="M5.00065 5.33325C5.18475 5.33325 5.33398 5.18401 5.33398 4.99992C5.33398 4.81582 5.18475 4.66659 5.00065 4.66659C4.81656 4.66659 4.66732 4.81582 4.66732 4.99992C4.66732 5.18401 4.81656 5.33325 5.00065 5.33325Z" fill={color}/>
    <path d="M8.39132 1.72392C8.14133 1.47385 7.80224 1.33333 7.44865 1.33325H2.66732C2.3137 1.33325 1.97456 1.47373 1.72451 1.72378C1.47446 1.97382 1.33398 2.31296 1.33398 2.66659V7.44792C1.33406 7.80151 1.47459 8.1406 1.72465 8.39059L7.52732 14.1933C7.83033 14.4943 8.24015 14.6633 8.66732 14.6633C9.09449 14.6633 9.50431 14.4943 9.80732 14.1933L14.194 9.80659C14.4951 9.50358 14.6641 9.09375 14.6641 8.66659C14.6641 8.23942 14.4951 7.82959 14.194 7.52659L8.39132 1.72392Z"
      stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.00065 5.33325C5.18475 5.33325 5.33398 5.18401 5.33398 4.99992C5.33398 4.81582 5.18475 4.66659 5.00065 4.66659C4.81656 4.66659 4.66732 4.81582 4.66732 4.99992C4.66732 5.18401 4.81656 5.33325 5.00065 5.33325Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
